import { render, staticRenderFns } from "./Statistiques.vue?vue&type=template&id=5908e235&scoped=true"
import script from "./Statistiques.vue?vue&type=script&lang=js"
export * from "./Statistiques.vue?vue&type=script&lang=js"
import style0 from "./Statistiques.vue?vue&type=style&index=0&id=5908e235&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5908e235",
  null
  
)

export default component.exports